import {
  Address,
  AloftArea,
  AloftPrice,
  ConstellationOneListing,
  expected,
  getC1MonthFromDateString,
  getLotAreaInSqft,
  isDefined,
  isUndefined,
  orUndefined,
  syntaxFNMA,
} from '@aloft/toolkit-shared';

import { proximityMiles } from '../../utils/proximityMiles.js';
import { Coordinates } from '../map/types.js';
import { VacantLandSalesProperty } from './types.js';

const TOTAL_LISTINGS_TO_SHOW = 6;

export function constellation1ListingsToVacantLandSalesProps(
  subjectCoordinates: Coordinates | undefined,
  listings: ConstellationOneListing[],
): VacantLandSalesProperty[] {
  const vacantLandSales = listings
    .map((listing) => {
      const saleMonth = getC1MonthFromDateString(listing.CloseDate);
      if (isUndefined(saleMonth)) {
        return undefined;
      }
      const saleDate = orUndefined(syntaxFNMA.isoMonthToAloftDate)(saleMonth);
      const address: Address = {
        CityName: listing.City,
        StateCode: listing.StateOrProvince,
        PostalCode: listing.PostalCode,
        AddressLineText: listing.UnparsedAddress,
      };
      if (isUndefined(address.AddressLineText)) {
        return undefined;
      }

      const subjectLatLong = isDefined(subjectCoordinates)
        ? { longitude: subjectCoordinates.lng, latitude: subjectCoordinates.lat }
        : undefined;
      const listingLatLong =
        isDefined(listing.Latitude) && isDefined(listing.Longitude)
          ? { longitude: listing.Longitude, latitude: listing.Latitude }
          : undefined;

      const distanceToSubject =
        isDefined(subjectLatLong) && isDefined(listingLatLong)
          ? +(proximityMiles(subjectLatLong, listingLatLong)?.toFixed(2) ?? 0)
          : undefined;

      return {
        id: expected(listing.ListingId),
        address,
        gla: AloftArea.fromNumber(listing.LivingArea, 'sqft'),
        lotSize: getLotAreaInSqft(listing),
        saleDate,
        salePrice: AloftPrice.fromDollarLike(listing.ClosePrice),
        distanceToSubject,
        latitude: listing.Latitude,
        longitude: listing.Longitude,
        listingID: listing.ListingId,
      };
    })
    .filter((val) => isDefined(val?.distanceToSubject))
    .sort((a, b) => (a?.distanceToSubject ?? 0) - (b?.distanceToSubject ?? 0))
    .filter(isDefined)
    .slice(0, TOTAL_LISTINGS_TO_SHOW);

  return vacantLandSales;
}
